import React from "react";

import type { ChatButtonOffsetChannel } from "./createChatButtonOffsetChannel";

// Inert default so trees without a provider (tests, storybook) read offset 0 safely.
const noopChannel: ChatButtonOffsetChannel = {
  get: () => 0,
  set: () => {},
  subscribe: () => () => {},
};

const ChatButtonOffsetContext = React.createContext<ChatButtonOffsetChannel>(noopChannel);

export default ChatButtonOffsetContext;
